exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/dialogs/leave-reason-dialog/leave-reason-dialog.component.css
// module id = ../../../../../src/app/dialogs/leave-reason-dialog/leave-reason-dialog.component.css
// module chunks = main